import { Search } from "lucide-react";
import { useCommandPalette } from "@/hooks/use-command-palette";

export function HeaderSearchBar() {
  const { setOpen } = useCommandPalette();

  return (
    <button
      onClick={() => setOpen(true)}
      className="hidden md:flex items-center gap-2 px-3 h-9 rounded-md border-2 border-primary bg-white hover:bg-primary/5 transition-colors text-sm cursor-pointer w-full"
      aria-label="Search or create (⌘K)"
      type="button"
    >
      <Search className="w-4 h-4 shrink-0 text-primary" />
      <span className="flex-1 text-left truncate text-gray-500">Search or create...</span>
      <kbd className="hidden lg:inline-flex items-center rounded border border-primary/30 bg-primary/5 px-1.5 py-0.5 text-xs font-medium text-primary/70">
        ⌘K
      </kbd>
    </button>
  );
}

export function HeaderSearchIcon() {
  const { setOpen } = useCommandPalette();

  return (
    <button
      onClick={() => setOpen(true)}
      className="md:hidden flex items-center justify-center h-9 w-9 rounded-md border-2 border-primary bg-white hover:bg-primary/5 transition-colors text-primary"
      aria-label="Search or create"
      type="button"
    >
      <Search className="w-4 h-4" />
    </button>
  );
}
